import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Utilities} from '@shared/utilities/utilities.model';
import {DigitalSignBaseService, OtpDialogData} from '@shared/components/core-sign/services/digital-sign-base-service';
import {SignersType} from '@shared/components/core-sign/models/enums.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-digital-sign-otp-dialog',
	templateUrl: './digital-sign-otp-dialog.component.html',
	styleUrls: ['./digital-sign-otp-dialog.component.scss']
})
export class DigitalSignOtpDialogComponent implements OnInit {

	ds_dossier_id: string;
	signers_id: string;
	mobile_number: string;

	form: FormGroup;
	otpSent: boolean = false;
	signer_type: SignersType;

	signersType: typeof SignersType = SignersType;
	private digitalSignService: DigitalSignBaseService;
	translateContext = TranslateContext;

	constructor(
		@Inject(MAT_DIALOG_DATA) private data: OtpDialogData,
		public fb: FormBuilder,
		public dialogRef: MatDialogRef<DigitalSignOtpDialogComponent>
	) {
		this.digitalSignService = this.data.service;
		this.signer_type = this.data.signer_type;
		this.ds_dossier_id = this.data.ds_dossier_id;
		this.signers_id = this.data.signers_id;
		this.mobile_number = this.data.mobile_number;
	}

	ngOnInit(): void {
		this.form = this.fb.group({
			...{
				opt_text: ['', [Validators.required, Validators.pattern(Utilities.patternOnlyNumber), Validators.minLength(8), Validators.maxLength(8)]],
			},
			...this.signer_type === SignersType.OPERATOR ?
				{
					pin_text: ['', [Validators.required, Validators.pattern(Utilities.patternOnlyNumber), Validators.minLength(8), Validators.maxLength(8)]]
				}
				: {}
		});
	}

	requestNewOpt(): void {
		this.otpSent = false;
		this.digitalSignService.newOtpSignerProcess(this.ds_dossier_id, this.signers_id).subscribe(
			resp => {
				this.otpSent = !!resp && resp.ok;
				setTimeout(() => this.otpSent = false, this.signer_type === SignersType.OPERATOR ? 8000 : 6000);
			}
		);
	}

	goBack(): void {
		this.dialogRef.close({
			success: false,
			values: null,
			error: null
		});
	}

	next(): void {
		if (this.form.invalid) {

			if (this.signer_type === SignersType.OPERATOR) {
				this.form.controls['pin_text'].markAsTouched();
				this.form.controls['pin_text'].markAsDirty();
			}

			this.form.controls['opt_text'].markAsTouched();
			this.form.controls['opt_text'].markAsDirty();
		} else {
			this.dialogRef.close({
				success: true,
				values: {
					...{
						otp: this.form.controls['opt_text'].value,
					},
					...this.signer_type === SignersType.OPERATOR ?
						{
							pin: this.form.controls['pin_text'].value
						}
						: {}
				},
				error: null
			});
		}
	}
}
